import React from 'react'
import PropTypes from 'prop-types'
import SelectVehicle from '../../3_Organisms/SelectVehicle/SelectVehicle'
import parse from 'html-react-parser';

function SelectVehicleStep({
  title,
  handleNextStep,
  introductionText,
  preDefinedModelId
}) {

  const onSelectVehicle = (data) => {
    const vehicleData = {
      id: data.id,
      isEV: data.is_ev,
      title: data.carline.title,
      model: data.carline.voi_leads_name,
      msrp: data.financial.msrp,
      year: data.year.url_slug,
      description: data.description,
      visual: data.visual
    }

    handleNextStep({ vehicleData: vehicleData })
  }

  return (
    <div className="mz-select-vehicle-step">
      {introductionText && (
        <div className="mz-select-vehicle-step__intro">
          <div className="mz-container">
            <div className="grid-inner-content-wide paragraph mz-select-vehicle-step__intro-inner">
              {parse(introductionText)}
            </div>
          </div>
        </div>
      )}
      <div className="mz-select-vehicle-step__top">
        <h5 className="mz-select-vehicle-step__title">{title}</h5>
      </div>
      <SelectVehicle onSelectVehicle={(data) => onSelectVehicle(data)} preDefinedModelId={preDefinedModelId} />
    </div>
  )
}

SelectVehicleStep.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  title: PropTypes.string,
  introductionText: PropTypes.string,
  preDefinedModelId: PropTypes.string,
}

SelectVehicleStep.defaultProps = {
  title: '',
  introductionText: '',
  preDefinedModelId: null,
}

export default SelectVehicleStep